module.exports = __webpack_public_path__ + "static/media/revenue_ops_use_case_3.27eafd5a.svg";